const cookieHelper = {
    setCookie: (name, value, h = 1, days = 1, path = '/', domain, secure = (typeof window !== 'undefined' && window.location.protocol === 'https:'), sameSite = 'Lax') => {
        let expires = '';
        const date = new Date();
        date.setTime(date.getTime() + ((h * days) * 60 * 60 * 1000));
        expires = `; expires=${date.toUTCString()}`;
    
        const domainString = domain ? `; domain=${domain}` : '';
        const isHttps = typeof window !== 'undefined' && window.location.protocol === 'https:';
        const secureString = (secure && isHttps) ? '; Secure' : '';
        const sameSiteString = sameSite ? `; SameSite=${sameSite}` : '';
        const stringVal = typeof value === 'string' ? value : JSON.stringify(value);
    
        try {
            if (typeof document !== 'undefined') {
                document.cookie = `${name}=${encodeURIComponent(stringVal)}${expires}; path=${path}${domainString}${secureString}${sameSiteString}`;
            }
        } catch (e) {
            // ignore
        }

        try {
            if (typeof localStorage !== 'undefined') {
                localStorage.setItem(name, stringVal);
            }
        } catch (e) {
            // ignore
        }
    },

    getCookie: (name) => {
        if (typeof document !== 'undefined') {
            const nameEQ = `${name}=`;
            const ca = document.cookie.split(';');
            for (let i = 0; i < ca.length; i++) {
                let c = ca[i];
                while (c.charAt(0) === ' ') c = c.substring(1, c.length);
                if (c.indexOf(nameEQ) === 0) {
                    const val = decodeURIComponent(c.substring(nameEQ.length, c.length));
                    if (val && val !== 'undefined' && val !== 'null') {
                        return val;
                    }
                }
            }
        }
        if (typeof localStorage !== 'undefined') {
            const localVal = localStorage.getItem(name);
            if (localVal && localVal !== 'undefined' && localVal !== 'null') {
                return localVal;
            }
        }
        return null;
    },

    deleteCookie: (name, path = '/', domain) => {
        const domainString = domain ? `; domain=${domain}` : '';
        if (typeof document !== 'undefined') {
            document.cookie = `${name}=; Max-Age=-99999999; path=${path}${domainString}`;
        }
        if (typeof localStorage !== 'undefined') {
            localStorage.removeItem(name);
        }
    }
};

export default cookieHelper;
